
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Bestcabserviceinpune() {



  const cardData =
  {
    keyword: 'Best Cab Service in Pune',
    heading: 'SHREE Tours & Travels: Best Cab Service in Pune',
    headingDescription: 'SHREE Tours & Travels is the best Cab service in Pune, offering reliable, comfortable and affordable taxi services for all your travel needs. Whether you need a one-way Cab, outstation taxi, airport transfer, or local city ride, we provide well-maintained vehicles and professional drivers to ensure a smooth journey. With on-time pickups, flexible booking options and competitive fares, we guarantee a hassle-free experience. Choose SHREE Tours & Travels for the most trusted and convenient Cab service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Best Cab Service in Pune",
      "description": "Experience the best Cab service in Pune with SHREE Tours & Travels. We offer punctual, reliable and affordable taxis for all your travel needs within the city and beyond."
    },
    {
      "name": "Affordable Taxi Service in Pune",
      "description": "Looking for an affordable taxi in Pune? Our budget-friendly taxi service ensures you travel in comfort without breaking the bank. Get the best deals for your ride around Pune."
    },
    {
      "name": "Luxury Cab Service Pune",
      "description": "Indulge in a premium travel experience with our luxury Cab service in Pune. Enjoy high-end vehicles like Innova Crysta, Mercedes and more for a lavish, comfortable ride."
    },
    {
      "name": "Private Taxi Service Pune",
      "description": "Book a private taxi service in Pune for a personalized, comfortable and stress-free travel experience. Enjoy privacy and convenience with our professional drivers and well-maintained cars."
    },
    {
      "name": "Reliable Pune Taxi",
      "description": "Trust our reliable taxi service in Pune for timely and safe travel. Whether it's a short ride or long-distance journey, our drivers ensure you reach your destination with ease."
    },
    {
      "name": "Pune Taxi Booking",
      "description": "Easily Book a Cab in Pune through our hassle-free booking system. Choose from a range of vehicles for your travel needs and enjoy seamless service with professional drivers."
    },
    {
      "name": "Pune to Outstation Cab Service",
      "description": "Travel comfortably to any outstation destination with our Pune to outstation Cab service. Our well-maintained vehicles and experienced drivers ensure a safe and smooth journey to your destination."
    },
    {
      "name": "Pune Local Travel Taxi Service",
      "description": "Explore Pune with our local travel taxi service. Whether you're visiting popular spots or need a quick errand run, we offer convenient taxi rides for all your local travel needs."
    },
    {
      "name": "Group Travel Taxi Service Pune",
      "description": "Traveling with a group? Our group travel taxi service in Pune ensures that everyone travels together comfortably. Choose from spacious vehicles for a pleasant group journey."
    },
    {
      "name": "Pune Car Hire",
      "description": "Hire a car in Pune for your trip, whether it's for a day or a week. We offer a wide variety of vehicles to suit your needs, from sedans to SUVs and more, ensuring a smooth and comfortable ride."
    },
    {
      "name": "Best Cab Booking Service in Pune",
      "description": "Book your taxi in Pune with ease through our best Cab booking service. Enjoy convenient online booking, reliable service and professional drivers for all your travel requirements."
    },
    {
      "name": "Best Airport Pickup and Drop in Pune",
      "description": "Make your airport transfers easy with our best airport pickup and drop service in Pune. We offer timely pickups, comfortable rides and professional drivers to ensure a smooth journey to and from the airport."
    }
  ],
  "tableData": [
    ["- Best Cab Service in Pune", "- Affordable Taxi Service in Pune"],
    ["- Luxury Cab Service Pune", "- Private Taxi Service Pune"],
    ["- Reliable Pune Taxi", "- Pune Taxi Booking"],
    ["- Pune to Outstation Cab Service", "- Pune Local Travel Taxi Service"],
    ["- Group Travel Taxi Service Pune", "- Pune Car Hire"],
    ["- Best Cab Booking Service in Pune", "- Best Airport Pickup and Drop in Pune"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Top-Quality Service",
      "WhyChoosedescription": "SHREE Tours & Travels offers the best Cab service in Pune, with a commitment to providing top-quality, reliable and comfortable transportation. We ensure that your journey is smooth, safe and enjoyable every time you choose us."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our team of professional and experienced drivers is one of the key reasons we stand out as the best Cab service in Pune. They are not only skilled drivers but also courteous and knowledgeable about the city's routes, ensuring a safe and pleasant experience."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles",
      "WhyChoosedescription": "We offer a wide selection of well-maintained vehicles to cater to every need. Whether you need a compact car for a short trip or a spacious vehicle for a group outing, our fleet is equipped to provide comfort, style and reliability for all types of journeys."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "At SHREE Tours & Travels, we believe in offering the best Cab service at affordable rates. Our pricing is transparent with no hidden charges, ensuring that you get the best value for your money without compromising on service quality."
    },
    {
      "WhyChooseheading": "Punctual and Timely Service",
      "WhyChoosedescription": "We understand the importance of time and our commitment to punctuality sets us apart. Whether you're heading to a business meeting or catching a flight, we ensure that you arrive at your destination on time, every time."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our Cab service in Pune is available 24/7, so you can book a ride whenever you need it. Whether it's early in the morning, late at night, or during a holiday, we are always ready to provide you with dependable and efficient transportation."
    },
    {
      "WhyChooseheading": "Seamless Booking Process",
      "WhyChoosedescription": "Booking a Cab with SHREE Tours & Travels is simple and hassle-free. You can book online via our user-friendly platform or call our customer support team for personalized assistance. We make sure the booking process is quick and convenient, ensuring a smooth experience from start to finish."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction above all else. We go the extra mile to ensure that every ride with us is comfortable, safe and hassle-free. Our goal is to exceed your expectations, making us the best choice for all your Cab service needs in Pune."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "What makes SHREE Tours & Travels the best Cab service in Pune?",
        answer: "SHREE Tours & Travels offers reliable, safe and comfortable Cab services with experienced drivers, a wide range of vehicle options and flexible booking options to ensure an excellent travel experience in Pune."
    },
    {
        question: "How can I book a Cab with SHREE Tours & Travels in Pune?",
        answer: "You can easily book a Cab through our website or by contacting our customer service for personalized assistance."
    },
    {
        question: "What types of Cabs are available with SHREE Tours & Travels in Pune?",
        answer: "We offer a variety of vehicles, including sedans, SUVs, MPVs and luxury cars, to cater to your travel needs in Pune."
    },
    {
        question: "Is the rental rate inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Are the drivers experienced and trained?",
        answer: "Yes, all of our drivers are experienced, well-trained and familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is the cancellation policy for Cab bookings with SHREE Tours & Travels?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for bookings in Pune?",
        answer: "We accept a variety of payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for safety during trips in Pune?",
        answer: "Yes, all of our vehicles come with full insurance coverage to ensure your safety and peace of mind while traveling."
    },
    {
        question: "Can I request a child seat for the Cab ride in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "How do I contact SHREE Tours & Travels for Cab bookings in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'SHREE Tours & Travels provided an amazing service for my trip in Pune. The car was clean, the driver was punctual and the entire experience was seamless.',
        name: 'Mr. Karan Mehta',
    },
    {
        text: 'I have used SHREE Tours & Travels multiple times in Pune. They are hands down the best Cab service in the city. Always on time and the drivers are very professional.',
        name: 'Miss. Neha Joshi',
    }
];













  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];



const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Looking for the best Cab service in Pune? Book affordable and luxury taxi services, private Cabs, reliable outstation taxis and group travel options with SHREE Tours & Travels. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/best-cab-service-pune.jpg",
    "https://shreetoursandtravels.in/img/luxury-cab-service-pune.jpg"
  ],
  "priceRange": "₹2000 - ₹8000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/best-cab-service-pune",
    "priceCurrency": "INR",
    "price": 2500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.9,
    "reviewCount": 1200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anjali Desai"
      },
      "datePublished": "2024-11-15",
      "reviewBody": "Excellent service! The Cab was clean and the driver was very professional. Highly recommend SHREE Tours & Travels for anyone looking for a reliable and affordable taxi service in Pune."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Suresh Naik"
      },
      "datePublished": "2024-11-22",
      "reviewBody": "I booked a Cab for a group trip from Pune to Mahabaleshwar. The service was smooth, on time and very comfortable. Will definitely use it again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Best Cab Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/best-cab-service-pune"
  },
  "keywords": "Best Cab Service in Pune, Affordable Taxi Service in Pune, Luxury Cab Service Pune, Private Taxi Service Pune, Reliable Pune Taxi, Pune Taxi Booking, Pune to Outstation Cab Service, Pune Local Travel Taxi Service, Group Travel Taxi Service Pune, Pune Car Hire, Best Cab Booking Service in Pune, Best Airport Pickup and Drop in Pune"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Best Cab Service in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Looking for the best Cab service in Pune? Book affordable and luxury taxi services, private Cabs, reliable outstation taxis and group travel options with SHREE Tours & Travels. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Best Cab Service in Pune, Affordable Taxi Service in Pune, Luxury Cab Service Pune, Private Taxi Service Pune, Reliable Pune Taxi, Pune Taxi Booking, Pune to Outstation Cab Service, Pune Local Travel Taxi Service, Group Travel Taxi Service Pune, Pune Car Hire, Best Cab Booking Service in Pune, Best Airport Pickup and Drop in Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/20.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestcabserviceinpune;